<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Orders</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="6">
          <el-input placeholder="Search" v-model="search_terms" class="input-with-select">
            <el-select v-model="search_option" slot="prepend" placeholder="Select">
              <el-option label="Purchase Number" value="1"></el-option>
              <el-option label="Order ID" value="2"></el-option>
            </el-select>
            <el-button @click="whichSearchFunctionToUse()" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>

        <el-col :span="17" :offset="1" class="text-right">
          <el-date-picker
            v-model="date_range"
            @change="getOrdersBetweenRange"
            :clearable="false"
            type="daterange"
            style="margin-right:10px;"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            value-format="yyyy-MM-dd"
            default-value="2018-01-01">
          </el-date-picker>

          <el-button 
            v-if="date_range.length"
            type="default" 
            @click="clearDates()">
            Clear Dates
          </el-button>

          <download-excel
            v-if="!display_overdue_orders"
            class="el-button el-button--default"
            :data="orders"
            :fields="headings"
            name="Orders.xls">
            Download Orders
          </download-excel>

          <el-button 
            v-if="!display_overdue_orders"
            type="default" 
            @click="getOverdueOrderItems(), display_overdue_orders = true">
            Overdue Orders
          </el-button>

          <el-button 
            v-if="display_overdue_orders"
            type="default" 
            @click="getOrders(), display_overdue_orders = false">
            All Orders
          </el-button>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-table
        v-show="display_overdue_orders == true"
        v-loading="loading"
        :data="overdue_order_items"
        resizable="true"
        border
        style="width: 100%">

        <el-table-column
          width="115%"
          prop="order_id"
          label="Order ID">
        </el-table-column>

        <el-table-column
          prop="product_name"
          label="Product">
        </el-table-column>

        <el-table-column
          prop="created_at"
          label="Created Date">
          <template slot-scope="scope">
            {{scope.row.created_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          prop="turnaround_time"
          label="Turnaround Time">
          <template slot-scope="scope">
            {{scope.row.turnaround_time + ' Days'}}
          </template>      
        </el-table-column>

        <el-table-column
          prop="due_date"
          label="Due Date">
          <template slot-scope="scope">
            {{scope.row.due_date | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          label="Actions"
          align="center"
          width="115%">
          <template slot-scope="scope">
            <el-button-group>
              <router-link :to="{ name: 'OrderView', params: { id: scope.row.order_id }}">
                <el-button 
                  icon="el-icon-search"
                  type="default" 
                  size="small">
                </el-button>
              </router-link>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-show="display_overdue_orders == false"
        v-loading="loading"
        :data="orders"
        resizable="true"
        border
        style="width: 100%">

        <el-table-column
          width="115%"
          prop="id"
          label="Order ID">
        </el-table-column>

        <el-table-column
          prop="company_name"
          label="Company">
        </el-table-column>

        <el-table-column
          prop="purchase_order_number"
          label="Purchase Order Number">
        </el-table-column>

        <el-table-column
          align="center"
          width="115%"
          prop="cart_total"
          label="Cart Total">
          <template slot-scope="scope">
            {{scope.row.cart_total | toCurrency}}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          width="115%"
          prop="created_at"
          label="Created Date">
          <template slot-scope="scope">
            {{scope.row.created_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          align="center"
          width="115%"
          prop="updated_at"
          label="Updated Date">
          <template slot-scope="scope">
            {{scope.row.updated_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <!-- <el-table-column
          prop="updated_at"
          label="Updated At"
          sortable>
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>
        </el-table-column> -->

        <el-table-column
          align="center"
          width="115%"
          label="Status">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status.label_color">{{scope.row.status.name}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          width="115%"
          label="Actions">
          <template slot-scope="scope">
            <el-button-group>
              <!-- <router-link :to="{ name: 'OrderEdit', params: { id: scope.row.id }}">
                <el-button 
                icon="el-icon-edit"
                type="default" 
                size="small"></el-button>
              </router-link> -->

              <router-link :to="{ name: 'OrderView', params: { id: scope.row.id }}">
                <el-button 
                  icon="el-icon-search"
                  type="default" 
                  size="small">
                </el-button>
              </router-link>

              <el-button
                :disabled="!hasRole('orders.can_delete')"
                icon="el-icon-delete" 
                type="default" 
                size="small"
                @click="deleteOrder(scope.row.id)">
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>      
    </el-row>

    <el-row :gutter="0">
      <el-col :span="24" :xs="24" :sm="24" class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current_page"
          :page-count="pagination.total_pages"
          :page-size="pagination.per_page"
          layout="total, prev, pager, next"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>

  .el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

</style>

<script>
  import Config from '@/store/Config.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return {
        page_alias: 'Order List',
        page_slug: 'order-list',

        search_option: '',

        permissions: store.permissions,
        config: Config.config,
        //columns: Tables.product_types.columns,
        //order_by: Tables.product_types.order_by,
        //sort_by: Tables.product_types.sort_by,

        table: {
          retail_price: true,
          id: false,
        },

        loading: true,
        search_terms: '',
        orders: [],
        date_range: '',
        start_date: '',
        end_date: '',
        default_date: new Date(),
        date_filter_on: false,
        display_overdue_orders: false,
        overdue_order_items: [],

        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          next_page_url: '',
          prev_page_url: '',
          from: 0,
          to: 0,
        },

        headings: {
          'ID': 'id',
          'Department': 'department',
          'Corporate ID': 'api_corporate_id',
          'Store ID': 'api_store_id',
          'First Name': 'customer_first_name',
          'Last Name': 'customer_last_name',
          'E-Mail': 'customer_email',
          'VAT': 'vat_number',
          'Address 1': 'billing_address_1',
          'Address 2': 'billing_address_2',
          'Address 3': 'billing_address_3',
          'City': 'billing_city',
          'State': 'billing_state',
          'Country': 'billing_country',
          'Post Code': 'billing_zip',
          'Phone Number': 'billing_telephone',
          'Mobile Number': 'billing_phone',
          'Company Name': 'company_name',
          'Address 1': 'shipping_address_1',
          'Address 2': 'shipping_address_2',
          'Address 3': 'shipping_address_3',
          'City': 'shipping_city',
          'State': 'shipping_state',
          'Country': 'shipping_country',
          'Post Code': 'shipping_zip',
          'Phone Number': 'shipping_telephone',
          'Mobile Number': 'shipping_mobile',
          'Shipping Method': 'shipping_methods.name',
          'Shipping Payment Method': 'payment_methods.name',
          'Goods Sub-Total': 'goods_subtotal',
          'Goods Tax': 'goods_tax',
          'Goods Total': 'goods_total',
          'Shipping Sub-Total': 'shipping_subtotal',
          'Shipping Tax': 'shipping_tax',
          'Shipping Total': 'shipping_total',
          'Cart Total': 'cart_total',
          'Order Status': 'order_status_id',
          'Job ID': 'job_id',
          'Purchase Order Number': 'purchase_order_number',
          'Created At': 'created_at',
          'Updated At': 'updated_at'
        },
      };
    },

    mounted: function() {
      const me = this;
      me.getOrders();
    },

    methods: {
      hasRole: function(role_name) {
        const me = this;

        if(me.permissions.user_roles.length > 0) {
          /* returns undefined if doesn't find the role */
          var role = _.find(me.permissions.user_roles, function(o) { 
            return o.name == role_name; 
          });

          /* doesn't enter if when undefined */
          if(role) {
            return true
          }
        }
        
        return false;
      },

      clearDates: function() {
        const me = this;
        me.date_filter_on = false;
        me.date_range = [];
        me.getOrders();
      },

      getOrdersBetweenRange: function(goToPage) {
        console.log('Get Orders Between Range Function');
        const me = this;

        me.loading = true;

        me.date_filter_on = true;
        me.start_date = me.date_range[0];
        me.end_date = me.date_range[1];

        me.$http.get(me.config.api + 'filter-orders-by-date', {params: {start_date: me.start_date, end_date: me.end_date, page: goToPage}}).then(
          response => {
          console.log('Get Orders Between Range Function - Success Getting Data');

          me.orders = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Orders Between Range Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      getOverdueOrderItems: function(goToPage) {
        console.log('Get Overdue Order Items Function');
        const me = this;

        me.loading = true;
        
        me.$http.get(me.config.api + 'order', {params: {overdue_order_items: 1, page: goToPage}}).then(
          response => {
          console.log('Get Overdue Order Items Function - Success Getting Data');

          me.overdue_order_items = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Overdue Order Items Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      getOrders: function(goToPage) {
        console.log('Get Orders Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'order', {params: {backend_call: 1, page: goToPage}}).then(
          response => {
          console.log('Get Orders Function - Success Getting Data');

          me.orders = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Orders Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          }); 

          me.loading = false;
        });
      },

      whichSearchFunctionToUse: function() {
        console.log('whichSearchFunctionToUse');
        const me = this;

        if(me.search_option == 1) {
          me.searchPurchaseNumber()
        } else me.searchOrderID();
      },

      searchPurchaseNumber: function(goToPage) {
        console.log('Search Purchase Number Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'order-search-purchase-no', {params: {search_terms: me.search_terms, page: goToPage}}).then(
          response => {
          console.log('Search Purchase Number Function - Success Getting Data');
          
          me.orders = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Search Purchase Number Function - Error Getting Data');

          me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
          });

          me.loading = false;
        });
      },

      searchOrderID: function(goToPage) {
        console.log('Search Order ID Function');
        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'order-search-id', {params: {search_terms: me.search_terms, page: goToPage}}).then(
          response => {
          console.log('Search Order ID Function - Success Getting Data')  
          
          me.orders = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Search Order ID Function - Error Getting Data');

          me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
          });

          me.loading = false;
        });
      },

      deleteOrder: function(id) {
        console.log('Delete Order Function');
        const me = this;

        me.$confirm('This will permanently delete the Order - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.$http.delete(me.config.api + 'order/{id}', {params: {id : id}}).then(
            response => {
            console.log('Delete Order Function - Success Deleting Data')  

            me.getOrders();

            me.$notify({
              title: 'Success',
              message: 'The Order Was Deleted',
              type: 'success',
            });
          }, response => {
            console.log('Delete Order Function - Error Deleting Data');
          });  
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete Canceled'
          });          
        });
      },

      handlePagination: function(response) {
        const me = this;

        me.pagination.total = response.body.total;
        me.pagination.per_page = response.body.per_page;
        me.pagination.current_page = response.body.current_page;
        me.pagination.last_page = response.body.last_page;
        me.pagination.next_page_url = response.body.next_page_url;
        me.pagination.prev_page_url = response.body.prev_page_url;
        me.pagination.from = response.body.from;
        me.pagination.to = response.body.to;
			},

      handleCurrentChange(val) {
        const me = this;
        if(me.date_filter_on) {
          me.getOrdersBetweenRange(val);
          console.log('calling date filtered pagination');
        } else if(me.display_overdue_orders) {
          me.getOverdueOrderItems(val)
          console.log('calling overdue order items pagination');
        } else {
          me.getOrders(val);
          console.log('calling non filtered pagination');
        }

        window.scrollTo(0,0);
      }
    }
  }
  
</script>


// WEBPACK FOOTER //
// src/pages/orders/OrderList.vue